import React, {Component} from 'react';
import {Sidebar} from 'react-adminlte-dash';
import {AllMenus} from "../../Menus";
import {withRouter} from 'react-router-dom'
import UserService from "../../services/UserService";
import StateStorage from '../../utils/StateStorage'
import {Col, Row} from 'react-bootstrap';
import BarcodeSelector from '../Barcode/BarcodeSelector';
import AssetTagsSelector from "../Asset/AssetTagsSelector";

export const SIDEBAR_COLLAPSE_STORAGE = "SIDEBAR_COLLAPSE"

class MySidebar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: !!UserService.currentUser,
      sideBarIsCollapsed: StateStorage.get(SIDEBAR_COLLAPSE_STORAGE) || false
    };
  }

  componentWillReceiveProps(nextProps) {
    StateStorage.set(SIDEBAR_COLLAPSE_STORAGE, nextProps.collapse)
    this.toggleSearchComponent(nextProps.collapse)
    this.setState({isAuthenticated: !!UserService.currentUser});
  }

  componentDidMount() {
    this.toggleSearchComponent(this.state.sideBarIsCollapsed)

    if (!this.state.sideBarIsCollapsed) {
      StateStorage.set(SIDEBAR_COLLAPSE_STORAGE, this.props.collapse)
    }

    this.setState({isAuthenticated: !!UserService.currentUser});
  }

  toggleSearchComponent(sideBarIsCollapsed) {
    const searchAssetComponent = document.querySelector('#search-asset')
    searchAssetComponent.style.display = !sideBarIsCollapsed ? 'inline' : 'none'
  }

  mountMenu({name, icon, path, children}, index) {
    return <Sidebar.Menu.Item key={index} title={name} icon={{className: icon}} onClick={() => {
      if (path) {
        if (path.indexOf('http') >= 0) {
          window.location = path;
        }
        this.props.history.push(path);
      }
    }}>
      {children.length > 0 ? children.map((item, index) => this.mountMenu(item, index)) : ''}
    </Sidebar.Menu.Item>
  }

  render() {
    const {isAuthenticated} = this.state;
    const menus = AllMenus.filter(
      ({isPrivate}) => isPrivate === isAuthenticated)
    .filter(({isPrivate, roles}) => isPrivate && (UserService.hasRoles(roles)))
    .map((item) => {
      item.children = item.children.filter(
        ({isPrivate}) => isPrivate === isAuthenticated)
      .filter(({isPrivate, roles}) => isPrivate && (UserService.hasRoles(roles)));
      return item;
    });

    return (
      <Sidebar.Menu header="Menus" key="1">
        <Row className="justify-content-center" id="search-asset">
          <Col md={11} sm={11} xs={8}>
            <AssetTagsSelector
              placeholder="Buscar EPC"
              onChange={asset => asset && this.props.history.push(`/track/${asset.tags.value}`)}
              title=" "
              style={{backgroundColor: '#35484f'}}
            />
          </Col>
          <Col md={11} sm={11} xs={8}>
            <BarcodeSelector
              placeholder="Buscar por código de barras"
              onChange={asset => asset && this.props.history.push(`/track/${asset.tags[0].value}`)}
              title=" "
              style={{backgroundColor: '#35484f'}}
            />
          </Col>
        </Row>
        {
          menus.map((item, index) => this.mountMenu(item, index))
        }
      </Sidebar.Menu>
    )
  };
}

export default withRouter(MySidebar);



// WEBPACK FOOTER //
// ./src/component/Sidebar/MySidebar.js